package org.catharsis.spendtel.core.impl

import org.catharsis.spendtel.core.api.AnalyticsApi
import org.catharsis.spendtel.feature.data.EventName
import org.catharsis.spendtel.feature.data.ScreenName

class NoOpAnalyticsApi : AnalyticsApi {
    override fun logClickEvent(eventName: EventName, extras: Map<String, Any>?) = Unit

    override fun logScreenViewed(screenName: ScreenName) = Unit
}
